import { get } from './requests'

export const getBusinessTimes = key => get(['business_time', 'get-business-times'], { key })
